import axios from './../../request/axios.js'
import api from './../../request/api.js'

const loginService = {
  login: function (params) {
    return axios.post(api.newLogin, params)
  }
}
export default loginService
